import { useContext, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useInstanceSelector } from '@s20/hooks/redux.hooks';
import { checkUserHasPermission } from '@s20/selectors/features/permissions.selectors';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../../Common';
import { FormContext } from '../../../common/forms/FormElements';
import ValidatedSelect from '../../../common/forms/ValidatedSelect';
import { ContractForm } from './ContractForm';

export const Contract = ({ companyId, dispatchOfficeLocationId }) => {
    const [showSlideForm, setShowSlideForm] = useState(false);
    const { values } = useContext(FormContext);
    const { isQuickRental } = values;

    const { data, isLoading } = useQuery({
        queryKey: isQuickRental
            ? ['quickRentalContractsForCustomer', companyId, dispatchOfficeLocationId]
            : ['contractsForCustomer', companyId, dispatchOfficeLocationId],
        queryFn: () => httpClient.js(
            isQuickRental
                ? ApiRoutes.typeAheads.quickRentalContractsForCustomer(companyId, dispatchOfficeLocationId)
                : ApiRoutes.typeAheads.contractsForCustomer(companyId, dispatchOfficeLocationId),
        ),
    });

    const hasEditPermission = useInstanceSelector(checkUserHasPermission, 'contract.create');

    return (
        <>
            <ValidatedSelect
                id="contractId"
                name="contractId"
                options={data}
                label="Select a contract for this job"
                required
                isLoading={isLoading}
                error="You must select a contract for this job"
                showAddButton={hasEditPermission}
                onAddButtonClick={() => setShowSlideForm(true)}
            />

            <ContractForm
                show={showSlideForm}
                setShowSlideForm={setShowSlideForm}
            />
        </>
    );
};